module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row drag-tab-container"
  }, [_c('div', {
    staticClass: "col-xs-11 col-sm-11 col-lg-11 col-xl-11"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('drag-tab', {
      key: tab.name,
      attrs: {
        "tab": tab,
        "tabs": _vm.tabs
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-1 col-lg-1 col-xl-1"
  }, [_c('button', {
    staticClass: "btn-plus",
    on: {
      "click": _vm.addTab
    }
  }, [_vm._v("+")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f2ed914","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DragNDrop/DragTabContainer.vue
// module id = 1938
// module chunks = 0